export const AMOUNT_TO_SHOW_PER_PAGE = 25;
export const getTotalPages = (amount, onOnePage = AMOUNT_TO_SHOW_PER_PAGE) => {
    return Math.ceil((amount || 0) / (onOnePage || 1));
};
//# sourceMappingURL=pagination.js.map